export { SensorProperties } from './SensorProperties';
export type { SensorPropertiesProps } from './SensorProperties';
